import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

const pulse = keyframes`
0% {
  transform: scale(1);
}
50% {
  transform: scale(1.1);
}
100% {
  transform: scale(1);
}
`;

const PhaseTypeSpan = styled.span(() => ({
  animation: `${pulse} 2500ms infinite`,
}));

export default PhaseTypeSpan;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/components/styledComponents.js